import { render, staticRenderFns } from "./user_flow_handler.vue?vue&type=template&id=0d1bc8fa&scoped=true"
import script from "./user_flow_handler.vue?vue&type=script&lang=js"
export * from "./user_flow_handler.vue?vue&type=script&lang=js"
import style0 from "./user_flow_handler.vue?vue&type=style&index=0&id=0d1bc8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1bc8fa",
  null
  
)

export default component.exports